import React from 'react';

interface IState {
  scrollActive:boolean;
  top?:boolean;
  hovered?:boolean;
  scrolling?:boolean;
}

let LastKnownScroll = 0;
/**
 *
 * StickyHeader component
 * @extends {React.Component<IState>}
 */
class StickyHeader extends React.Component {

  public state: IState;

  constructor (props: any) {
      super(props);
      this.state = {
        scrollActive:true,
        top:true,
        scrolling:false
      };
  }

  public componentDidMount = async() => {
    window.addEventListener("scroll",this.processScroll);
    this.processScroll();
  }

  public componentWillUnmount() {
    window.removeEventListener("scroll",this.processScroll);
  }

  public processScroll = () => {
    if(window.pageYOffset < 80){
      this.transitionStickyHeader({
        scrollActive:true,
        scrolling:false
      })
    } else if(LastKnownScroll > window.pageYOffset){
      this.transitionStickyHeader({
        scrolling:true,
        top:false,
        scrollActive:true
      })
    } else{
      this.transitionStickyHeader({
        scrolling:true,
        top:false,
        scrollActive:false
      })
    }
    LastKnownScroll = window.pageYOffset;
  }

  public transitionStickyHeader = (state:any) => {
    this.setState(state)
  }


  public hover = () => {
    this.setState({
      hovered:true
    })
  }
  public unHover = () => {
    this.setState({
      hovered:false
    })
  }

  public render(): JSX.Element {
    const {children} = this.props;
    let scrolledClass = this.state.scrollActive ? '' : 'hidden';
    let topClass = this.state.top ? 'top' : '';
    let scrolling = this.state.scrolling ? 'scrolling' : '';
    let hoveredClass = this.state.hovered ? 'hovered' : '';
    let classCompiled = 'sticky-header '+scrolling+' '+scrolledClass+' '+topClass+' '+hoveredClass;
    return (
      <div className={'top '+classCompiled} onMouseEnter={this.hover} onMouseLeave={this.unHover}>
        {children}
      </div>
    );
  }
}

export default StickyHeader;
